// Pure Firefly motion-speed helpers — shared by client, server, and tests.

/** v1.0 motion tuning — 1.0 = base spec timings; 1.5 = 1.5× faster. */
export const FIREFLY_DEFAULT_MOTION_SPEED_MULTIPLIER = 1.5;

export const FIREFLY_MOTION_SPEED_MIN = 0.5;
export const FIREFLY_MOTION_SPEED_MAX = 2.0;
export const FIREFLY_MOTION_SPEED_STEP = 0.1;

/** @deprecated Local per-browser tuning removed — platform settings only. */
export const FIREFLY_MOTION_SPEED_STORAGE_KEY = "bb-dev-firefly-motion-speed";

export function clampFireflyMotionSpeedMultiplier(value: number): number {
  if (!Number.isFinite(value)) {
    return FIREFLY_DEFAULT_MOTION_SPEED_MULTIPLIER;
  }
  const stepped =
    Math.round(value / FIREFLY_MOTION_SPEED_STEP) * FIREFLY_MOTION_SPEED_STEP;
  const normalized = Math.round(stepped * 10) / 10;
  return Math.min(
    FIREFLY_MOTION_SPEED_MAX,
    Math.max(FIREFLY_MOTION_SPEED_MIN, normalized),
  );
}

export function parseFireflyMotionSpeedMultiplier(value: unknown): number {
  const n = typeof value === "number" ? value : Number(value);
  return clampFireflyMotionSpeedMultiplier(n);
}

/** Step within clamp range (for +/- controls). */
export function stepFireflyMotionSpeedMultiplier(
  current: number,
  deltaSteps: number,
): number {
  return clampFireflyMotionSpeedMultiplier(
    current + deltaSteps * FIREFLY_MOTION_SPEED_STEP,
  );
}
